/**
 * Champ code promo du panier (tiroir + page panier).
 *
 * Écriture : POST /cart/update.js avec { discount }. Ce point d'entrée REMPLACE
 * l'ensemble des codes posés, contrairement à /discount/<code> qui les empile
 * sans jamais les nettoyer. Vérifié en direct sur la boutique.
 *
 * Lecture : la réponse porte `discount_codes: [{ code, applicable }]`.
 * ⚠ `applicable: false` ne distingue PAS un code inconnu d'un code valide sans
 * article éligible au panier. Shopify renvoie exactement la même chose dans les
 * deux cas, d'où un message unique et honnête côté client.
 *
 * Rendu : strictement délégué au thème, comme assets/cart-auto-add.js. On ne
 * fabrique aucun HTML de panier à la main.
 *
 * Le formulaire vit DANS les sections re-rendues : tous les écouteurs sont donc
 * délégués au document, jamais posés sur les éléments eux mêmes.
 */
(function () {
  'use strict';

  // Le gabarit est rendu sur deux surfaces, donc la balise script peut être
  // servie deux fois sur la même page. Sans ce garde, les écouteurs délégués
  // seraient posés en double.
  if (window.__promoPanierInit) return;
  window.__promoPanierInit = true;

  var URL_UPDATE = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
  var enCours = false;

  function postConfig(body) {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    };
  }

  // ----- Rendu : mêmes hôtes et mêmes sélecteurs que le thème -----

  // Le tiroir est présent dans le DOM de TOUTES les pages, y compris /cart.
  // Ne re-rendre que le premier hôte trouvé laisserait donc la page panier
  // figée pendant que le tiroir, lui, serait à jour. On sert les deux.
  function hotes() {
    return [
      document.querySelector('cart-drawer-items'),
      document.querySelector('cart-items')
    ].filter(function (h) { return h && typeof h.getSectionsToRender === 'function'; });
  }

  function sectionsDemandees() {
    var ids = [];
    hotes().forEach(function (h) {
      h.getSectionsToRender().forEach(function (s) {
        if (s.section && ids.indexOf(s.section) === -1) ids.push(s.section);
      });
    });
    return ids.length ? ids : null;
  }

  function appliquerEtat(etat) {
    if (!etat || etat.errors || !etat.sections) return;
    hotes().forEach(function (h) {
      h.getSectionsToRender().forEach(function (section) {
        var el = document.getElementById(section.id);
        if (!el) return;
        var cible = (section.selector && el.querySelector(section.selector)) || el;
        var html = etat.sections[section.section];
        if (html == null) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = section.selector ? doc.querySelector(section.selector) : doc.body;
        cible.innerHTML = src ? src.innerHTML : html;
      });
    });
    setTimeout(function () {
      if (typeof window.initUpsellCarousel === 'function') window.initUpsellCarousel();
      if (typeof window.initUpsellDiscounts === 'function') window.initUpsellDiscounts();
      if (typeof window.initCartVariantSelectors === 'function') window.initCartVariantSelectors();
    }, 0);
  }

  // ----- Affichage après re-rendu -----
  // Les éléments d'avant le rendu sont détruits : on retrouve les nouveaux.

  function afficherMessage(texte, info) {
    document.querySelectorAll('[data-promo-message]').forEach(function (p) {
      if (!texte) {
        p.hidden = true;
        p.textContent = '';
        return;
      }
      p.textContent = texte;
      p.classList.toggle('promo__message--info', !!info);
      p.hidden = false;
    });
  }

  function restaurerSaisie(valeur) {
    if (!valeur) return;
    document.querySelectorAll('[data-promo-champ]').forEach(function (champ) {
      champ.value = valeur;
    });
  }

  function verrouiller(actif) {
    document.querySelectorAll('[data-promo-valider]').forEach(function (b) {
      b.disabled = actif;
      b.textContent = actif ? 'Un instant' : 'Appliquer';
    });
  }

  // ----- Écriture -----

  function envoyer(code) {
    var corps = { discount: code };
    var sections = sectionsDemandees();
    if (sections) {
      corps.sections = sections;
      corps.sections_url = window.location.pathname;
    }
    return fetch(URL_UPDATE, postConfig(corps)).then(function (r) { return r.json(); });
  }

  function estApplicable(etat, code) {
    var liste = (etat && etat.discount_codes) || [];
    var vise = code.toUpperCase();
    return liste.some(function (d) {
      return String(d.code || '').toUpperCase() === vise && d.applicable === true;
    });
  }

  function appliquer(code) {
    if (enCours) return;
    code = String(code || '').trim();
    if (!code) {
      afficherMessage('Saisissez un code promo.', true);
      return;
    }
    enCours = true;
    verrouiller(true);
    afficherMessage('');

    envoyer(code)
      .then(function (etat) {
        appliquerEtat(etat);
        if (estApplicable(etat, code)) {
          afficherMessage('');
          return null;
        }
        // Refusé. On retire le code plutôt que de le laisser traîner jusqu'au
        // paiement : le client doit voir exactement ce qui est appliqué.
        return envoyer('').then(function (apresRetrait) {
          appliquerEtat(apresRetrait);
          restaurerSaisie(code);
          afficherMessage('Ce code ne s’applique pas à votre panier.');
        });
      })
      .catch(function (e) {
        console.warn('[cart-discount] échec', e);
        restaurerSaisie(code);
        afficherMessage('Code non appliqué, réessayez dans un instant.');
      })
      .then(function () {
        enCours = false;
        verrouiller(false);
      });
  }

  function retirer() {
    if (enCours) return;
    enCours = true;
    afficherMessage('');
    envoyer('')
      .then(appliquerEtat)
      .catch(function (e) { console.warn('[cart-discount] retrait échoué', e); })
      .then(function () { enCours = false; });
  }

  // ----- Écouteurs délégués -----

  document.addEventListener('click', function (e) {
    var valider = e.target.closest && e.target.closest('[data-promo-valider]');
    if (valider) {
      e.preventDefault();
      var bloc = valider.closest('[data-promo]');
      var champ = bloc && bloc.querySelector('[data-promo-champ]');
      appliquer(champ ? champ.value : '');
      return;
    }
    var croix = e.target.closest && e.target.closest('[data-promo-retirer]');
    if (croix) {
      e.preventDefault();
      retirer();
    }
  });

  // Entrée valide le code sans soumettre le formulaire du panier autour.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var champ = e.target.closest && e.target.closest('[data-promo-champ]');
    if (!champ) return;
    e.preventDefault();
    e.stopPropagation();
    appliquer(champ.value);
  });
})();
